import * as React from "react";
const SvgFiRrAccident = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-accident_svg__a)">
      <path
        fill="#062147"
        d="M4.737 11.273a2.5 2.5 0 1 1 3.526-3.546 2.5 2.5 0 0 1-3.526 3.546m16.701 12.073a1 1 0 0 1-1.284.592l-3.817-1.407a1 1 0 0 0-.613-.024L10.7 23.902c-1.464.333-2.91-.404-3.477-1.748L4.167 15H2.5A2.503 2.503 0 0 1 0 12.5V9a1 1 0 0 1 2 0v3.5a.5.5 0 0 0 .5.5h2.934l6.132-.817a.5.5 0 0 0 .434-.496V8a1 1 0 0 1 2 0v3.687a2.51 2.51 0 0 1-2.169 2.479l-1.592.212 2.102 5.08 2.45-2.54a3.02 3.02 0 0 1 2.159-.917H20a1 1 0 1 1 0 2h-3.05c-.27 0-.532.11-.72.306l-2.615 2.71 1.574-.436a3 3 0 0 1 1.839.075l3.818 1.407a1 1 0 0 1 .593 1.284zm-10.329-1.633L8.187 14.65l-1.887.252 2.764 6.47c.19.452.671.695 1.146.59zM22.977 7.668l-2.189-1.122a.69.69 0 0 1-.345-.81l.709-2.356a1.001 1.001 0 0 0-1.35-1.208l-2.091.89a.687.687 0 0 1-.901-.363L15.92.608A1 1 0 0 0 15.036 0a.99.99 0 0 0-.926.543l-1.122 2.189a.69.69 0 0 1-.81.345l-2.356-.708a1.002 1.002 0 0 0-1.208 1.35l1.019 2.393a1 1 0 1 0 1.84-.784l-.182-.43.311.095a2.685 2.685 0 0 0 3.166-1.347l.148-.29.054.128a2.69 2.69 0 0 0 3.524 1.419l.127-.054-.094.312a2.686 2.686 0 0 0 1.348 3.165l.453.232-.454.232a2.686 2.686 0 0 0-1.347 3.165l.094.312-.126-.053a2.7 2.7 0 0 0-1.765-.12 1 1 0 1 0 .529 1.929.7.7 0 0 1 .453.03l2.091.89q.19.08.392.08a1 1 0 0 0 .958-1.288l-.709-2.355a.69.69 0 0 1 .345-.81l2.189-1.122a1 1 0 0 0 0-1.78z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-accident_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAccident;
